var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.span)?_c('span',{ref:"eSpan",staticClass:"ellipsis-div",attrs:{"placeholder":_vm.displayText},domProps:{"innerHTML":_vm._s(_vm.usePlaceholder ? '' : _vm.displayText)}}):_c('div',{ref:"eDiv",staticClass:"ellipsis-div",attrs:{"placeholder":_vm.displayText},domProps:{"innerHTML":_vm._s(_vm.usePlaceholder ? '' : _vm.displayText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }